var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"form",attrs:{"label-position":"right","label-width":"80px"}},[_vm._t("content"),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.submitForm}},[_vm._v("保存")]),_c('el-button',[_vm._v("取消")])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }